"use client";

import { useEffect } from "react";
import { getInitialMuted, setMuted, unlockAudio } from "@/lib/game/audio";

/** Unlocks Web Audio on first user interaction anywhere in the app. */
export function AudioInit() {
  useEffect(() => {
    setMuted(getInitialMuted());

    const options: AddEventListenerOptions = { capture: true, passive: true };

    const unlock = () => {
      unlockAudio();
      document.removeEventListener("touchstart", unlock, options);
      document.removeEventListener("pointerdown", unlock, options);
      document.removeEventListener("click", unlock, options);
      document.removeEventListener("keydown", unlock, options);
    };

    // Capture phase so Pixi canvas touches unlock audio before scene handlers run.
    document.addEventListener("touchstart", unlock, options);
    document.addEventListener("pointerdown", unlock, options);
    document.addEventListener("click", unlock, options);
    document.addEventListener("keydown", unlock, options);

    return () => {
      document.removeEventListener("touchstart", unlock, options);
      document.removeEventListener("pointerdown", unlock, options);
      document.removeEventListener("click", unlock, options);
      document.removeEventListener("keydown", unlock, options);
    };
  }, []);

  return null;
}
